<div fxLayoutGap="20px" fxLayout="column" fxFlex>
  <div fxLayoutAlign.gt-md="space-between center">
    <h1>{{ tituloPage }}</h1>

    <div fxLayout="row" fxLayoutAlign="end start">
      <app-back-button (back)="voltar()"></app-back-button>
    </div>
  </div>

  <mat-card class="card-success">
    <p>Abaixo constam informações do processo digital obtidas do SIGAD a partir do número do processo cadastrado para o concurso.</p><br/>
    <ul>
      <li>Caso a localização do processo seja distinta da unidade promovendo o concurso, não será possível atualizar o processo com as informações do concurso.</li>
      <li>O administrador do concurso deve ter permissão no SIGAD para atualizar o processo conforme a unidade de protocolo deste. Consulte no SIGAD as unidades administrativas que seu usuário tem permissão.</li>
      <li>Na seção abaixo "Atualizar processo digital SIGAD" utilize as operações habilitadas conforme as etapas do concurso.</li>
    </ul>
    <br/>
    <a href="https://detic.unicamp.br/documento/manual-sistema-de-concursos-administrador/#processo-digital" target="_blank">Clique aqui para consultar a seção do Processo Digital no Manual do Sistema para mais informações.</a>
  </mat-card>
  <mat-card>
    <mat-card-content>
      <form [formGroup]="protocoloForm" disabled fxLayout="column" fxLayoutGap="20px">
        <fieldset fxFlex="100%">
          <legend>Ficha de protocolo</legend>
          <div fxLayout.gt-md="row" fxLayoutGap="20px">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Número do protocolo</mat-label>
              <input matInput formControlName="numero" readonly />
            </mat-form-field>
          </div>

          <div fxLayout.gt-md="row" fxLayoutGap="20px">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Unidade de Protocolo/Responsabilidade</mat-label>
              <input matInput formControlName="unidadeProtocolo" readonly />
            </mat-form-field>
          </div>

          <div fxLayout.gt-md="row" fxLayoutGap="20px">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Procedência</mat-label>
              <input matInput formControlName="procedencia" readonly />
            </mat-form-field>
          </div>

          <div fxLayout.gt-md="row" fxLayoutGap="20px">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Categoria de Protocolo</mat-label>
              <input matInput formControlName="categoria" readonly />
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Tipo de Meio</mat-label>
              <input matInput formControlName="tipoMeio" readonly />
            </mat-form-field>
          </div>

          <div fxLayout.gt-md="row" fxLayoutGap="20px">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Data de Protocolo</mat-label>
              <input matInput formControlName="dataCadastro" readonly />
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Usuário</mat-label>
              <input matInput formControlName="usuarioCadastro" readonly />
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Situação do protocolo</mat-label>
              <input matInput formControlName="situacao" readonly />
            </mat-form-field>
          </div>
        </fieldset>

        <fieldset fxFlex="100%">
          <legend>Classificação e Assunto</legend>

          <div fxLayout.gt-md="row" fxLayoutGap="20px">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Tipo Documental</mat-label>
              <input matInput formControlName="tipoDocumental" readonly />
            </mat-form-field>
          </div>

          <div fxLayout.gt-md="row" fxLayoutGap="20px">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Classificação</mat-label>
              <input matInput formControlName="classificacao" readonly />
            </mat-form-field>
          </div>

          <div fxLayout.gt-md="row" fxLayoutGap="20px">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Assunto</mat-label>
              <textarea matInput formControlName="assunto" readonly></textarea>
            </mat-form-field>
          </div>

          <div fxLayout.gt-md="row" fxLayoutGap="20px">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Acesso</mat-label>
              <input matInput formControlName="acesso" readonly />
            </mat-form-field>
          </div>
        </fieldset>

        <mat-card class="card-danger-sm" *ngIf="protocoloForm.get('localizacao')?.errors">
          A localização do documento (processo no SIGAD) precisa estar na unidade responsável pelo concurso para a
          funcionalidade "Atualizar processo digital" ser habilitada para uso.
        </mat-card>

        <fieldset fxFlex="100%">
          <legend>Localização do Documento</legend>

          <div fxLayout.gt-md="row" fxLayoutGap="20px">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Unidade</mat-label>
              <input matInput formControlName="localizacao" readonly />
              <mat-hint>Unidade onde o documento está localizado, deve ser a mesma do usuário logado.</mat-hint>
            </mat-form-field>
          </div>
        </fieldset>

        <inscricoes-processo-digital-acoes
          [hasFormErrors]="!protocoloForm.valid"
          [statusInscricoes]="statusInscricoes"
          [statusDeclaracoes]="statusDeclaracoes"
          [statusResultadoFase1]="statusResultadoFase1"
          [statusResultadoFase2]="statusResultadoFase2"
          [prazoInscricaoEncerrado]="prazoInscricaoEncerrado"
          [temInscricoesAguardandoAnalise]="temInscricoesAguardandoAnalise"
          (enviarDocsEv)="enviarDocs()"
          (enviarDeclaracoesEv)="enviarDeclaracoes()"
          (enviarClassificacaoFase1Ev)="enviarClassificacaoFase1()"
          (enviarClassificacaoFase2Ev)="enviarClassificacaoFase2()"
          (verificarIntegridadeEv)="verificarIntegridade($event)"></inscricoes-processo-digital-acoes>
      </form>
    </mat-card-content>
    <mat-card-actions>
      <div
        fxLayoutAlign.gt-md="end center"
        fxLayoutAlign.lt-md="center stretch"
        fxLayout.lt-md="column"
        fxLayoutGap="20px">
        <app-cancel-button (cancel)="voltar()"></app-cancel-button>
      </div>
    </mat-card-actions>
    <mat-progress-bar mode="determinate" *ngIf="progressBarShow" [value]="progressBarValue"></mat-progress-bar>
  </mat-card>
</div>
